var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlltickets(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M23.375 13.75C23.375 11.5275 21.8945 9.66317 19.875 9.0355V8.5C19.875 4.15767 16.3423 0.625 12 0.625C7.65767 0.625 4.125 4.15767 4.125 8.5V9.0355C2.1055 9.66317 0.625 11.5263 0.625 13.75C0.625 16.4835 2.84983 18.7083 5.58333 18.7083H6.16667C7.2925 18.7083 8.20833 17.7925 8.20833 16.6667V10.8333C8.20833 9.7075 7.2925 8.79167 6.16667 8.79167H5.875V8.5C5.875 5.1225 8.6225 2.375 12 2.375C15.3775 2.375 18.125 5.1225 18.125 8.5V8.79167H17.8333C16.7075 8.79167 15.7917 9.7075 15.7917 10.8333V16.6667C15.7917 17.7925 16.7075 18.7083 17.8333 18.7083H18.013C17.6152 20.3767 16.1218 21.625 14.3333 21.625H11.734C11.251 21.625 10.859 22.017 10.859 22.5C10.859 22.983 11.251 23.375 11.734 23.375H14.3333C17.166 23.375 19.4818 21.2307 19.8097 18.4843C21.863 17.8777 23.375 15.997 23.375 13.75Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlltickets);
export default __webpack_public_path__ + "static/media/alltickets.d7ead8feadd20c0720b65cfee5835d78.svg";
export { ForwardRef as ReactComponent };